import { render, staticRenderFns } from "./integral-statistics.vue?vue&type=template&id=0245c554&scoped=true&"
import script from "./integral-statistics.vue?vue&type=script&lang=js&"
export * from "./integral-statistics.vue?vue&type=script&lang=js&"
import style0 from "./integral-statistics.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./integral-statistics.vue?vue&type=style&index=1&id=0245c554&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0245c554",
  null
  
)

export default component.exports